<script>
export default {
    name: "RetailerSearchGeoLocateUser",
    emits: ['updated-position'],

    data() {
        return {
            vModel : ''
        }
    },

    props: {
        query: {
            type: String,
            default : ''
        }
    },

    created() {
    },

    methods: {

        getUsersGeoPosition(force=false)
        {
            // console.log('getUsersGeoPosition()');

            if (this.query.length && force === false) {
                console.log('ignore');
                return false;
            }

            // console.log('😱 geolocate');

            if (! navigator.geolocation) {
                console.warn('Geolocation is not supported');
            } else {
                // console.log('locating ...');
                const options = {enableHighAccuracy: true, maximumAge: 10000};
                navigator.geolocation.getCurrentPosition(
                    this.getUsersGeoPosition__success,
                    this.getUsersGeoPosition__error, options
                );
            }
        },

        getUsersGeoPosition__success(position)
        {
            this.$emit('updated-position', position.coords.latitude, position.coords.longitude, true);
        },

        getUsersGeoPosition__error()
        {
            console.warn('geo position not allowed');
        },

    }
}
</script>

<template>

    <div class="retailer-search__input">
        <button type="button" class="btn btn--primary gps-btn" @click="getUsersGeoPosition(true)">
            <span class="svg-icon retailer-search__map-icon"><svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1031_727)"><path d="M7.5 0C3.55263 0 0 2.90736 0 7.48219C0 10.3468 2.32456 13.7672 6.88597 17.7007C7.23684 18 7.76316 18 8.11404 17.7007C12.6754 13.7672 15 10.3468 15 7.48219C15 2.90736 11.4474 0 7.5 0ZM7.5 9.10689C6.49123 9.10689 5.61404 8.29454 5.61404 7.26841C5.61404 6.28504 6.49123 5.47268 7.5 5.47268C8.50877 5.47268 9.38597 6.28504 9.38597 7.26841C9.38597 8.29454 8.50877 9.10689 7.5 9.10689Z" fill="black"></path></g><defs><clipPath id="clip0_1031_727"><rect width="15" height="18" fill="black"></rect></clipPath></defs></svg></span>
            <span>Vis verksted i nærheten</span>
        </button>
    </div>
</template>

